import {
  ADD_BROKER_RESOURCE,
  ADD_BROKER_RESOURCE_ERROR,
  ADD_BROKER_RESOURCE_SUCCESS,
  DELETE_BROKER_RESOURCE,
  DELETE_BROKER_RESOURCE_ERROR,
  DELETE_BROKER_RESOURCE_SUCCESS,
  GET_BROKER_RESOURCE,
  GET_BROKER_RESOURCE_FAIL,
  GET_BROKER_RESOURCE_SUCCESS,
  UPDATE_BROKER_RESOURCE,
  UPDATE_BROKER_RESOURCE_FAIL,
  UPDATE_BROKER_RESOURCE_SUCCESS,
} from "./actionTypes"

export const addBrokerResource = (resource, callback) => ({
  type: ADD_BROKER_RESOURCE,
  payload: { resource, callback },
})

export const addBrokerResourceSuccess = resource => ({
  type: ADD_BROKER_RESOURCE_SUCCESS,
  payload: resource,
})

export const addBrokerResourceError = error => ({
  type: ADD_BROKER_RESOURCE_ERROR,
  payload: error,
})

export const getBrokerResource = (brokerId) => ({
  type: GET_BROKER_RESOURCE,
  brokerId,
})

export const getBrokerResourceSuccess = resources => ({
  type: GET_BROKER_RESOURCE_SUCCESS,
  payload: resources,
})

export const getBrokerResourceFail = error => ({
  type: GET_BROKER_RESOURCE_FAIL,
  payload: error,
})

export const updateBrokerResource = (resource, callback) => ({
  type: UPDATE_BROKER_RESOURCE,
  payload: { resource, callback },
})

export const updateBrokerResourceSuccess = resource => ({
  type: UPDATE_BROKER_RESOURCE_SUCCESS,
  payload: resource,
})

export const updateBrokerResourceFail = error => ({
  type: UPDATE_BROKER_RESOURCE_FAIL,
  payload: error,
})

export const deleteBrokerResource = (resource, callback) => ({
  type: DELETE_BROKER_RESOURCE,
  payload: { resource, callback },
})

export const deleteBrokerResourceSuccess = resource => ({
  type: DELETE_BROKER_RESOURCE_SUCCESS,
  payload: resource,
})

export const deleteBrokerResourceError = error => ({
  type: DELETE_BROKER_RESOURCE_ERROR,
  payload: error,
})
